import LeaderBoard from "../components/LeaderBoard";
import PrizePool from "../components/PrizePool";

export const TABLE_VIEW = new Map([
  ['leaderboard', LeaderBoard],
  ['prizepool', PrizePool]
]);
